import { Badge, Button, Card, Form, Image, Input, Popconfirm, Tag, Upload } from 'antd';
import React, { useState } from 'react';
import StepNoItem from '../../../helpers/components/step_no_item';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import RichTextEditor from '../../../helpers/components/rich_text_editor';

const { TextArea } = Input;
const ParkOverview = ({ form, beforeUpload = () => {}, removeImage = () => {}, image, park, email_image }) => {
    const [state, setState] = useState({
        remove_loading : false,
    })

    const onDeltaChange = (html) => {
        form.setFieldsValue({ description : html || null, });
    }

    const onBannerChange = (html) => {
        form.setFieldsValue({ banner_text : html || null, });
    }

    return (
        <>
            <Card
            // headStyle={{ padding : 12, }}
            styles={{ header : { padding : 12, } }}
            title={(
                <>
                    <div style={{textAlign : 'start',}}>
                        <StepNoItem no={2} text={'Park Overview'} />
                    </div>
                </>
            )}
            >
                <div>
                    <div style={{ textAlign : 'start', }}>
                        <Form.Item label="Logo" style={{ marginBottom : 0, }}>
                            <Badge
                            offset={[-4, 0]}
                            count={(
                                <Button onClick={() => removeImage('image')} loading={state?.remove_loading} size='small' icon={<CloseOutlined />}></Button>
                            )}
                            >
                                <Form.Item name={'logo_image'}>
                                    <Upload
                                        name="logo_image"
                                        listType='picture-card'
                                        beforeUpload={(file) => beforeUpload('logo_image', file)}
                                        showUploadList={false}
                                        style={{ width: 104, height: 104, overflow: 'hidden' }} 
                                    >
                                        {image ? (
                                            <Image
                                                preview={false}
                                                src={image}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 86, height: 86 }}>
                                                <PlusOutlined />
                                                <div style={{ marginTop: 8 }}>Upload</div>
                                            </div>
                                        )}
                                    </Upload>
                                </Form.Item>
                            </Badge>
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label='Park Code' style={{textAlign : 'start',}}>
                            <Tag color='blue' style={{ border : 'none', }}>{park?.park_code}</Tag>
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label='Park Name' name={'name'}>
                            <Input />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label='Address' name={'address'}>
                            <TextArea
                            rows={4}
                            style={{ resize : 'none', }}
                            />
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item label="Description" name="description">
                            <div>
                                <RichTextEditor
                                placeholder='Enter descriptions'
                                onChange={onDeltaChange}
                                value={park?.description}
                                />
                            </div>
                        </Form.Item>
                    </div>

                    <div>
                        <Form.Item label="Banner" name="banner_text">
                            <div>
                                <RichTextEditor
                                placeholder='Enter banner'
                                onChange={onBannerChange}
                                value={park?.banner_text}
                                />
                            </div>
                        </Form.Item>
                    </div>

                    <div style={{ textAlign : 'start', marginTop: 16 }}>
                        <Form.Item label="Email Image" style={{ marginBottom : 0, }}>
                            <Badge
                            offset={[-4, 0]}
                            count={(
                                <Button onClick={() => removeImage('email_image')} loading={state?.remove_loading} size='small' icon={<CloseOutlined />}></Button>
                            )}
                            >
                                <Form.Item name={'email_image'}>
                                    <Upload
                                        name="email_image"
                                        listType='picture-card'
                                        beforeUpload={(file) => beforeUpload('email_image', file)}
                                        showUploadList={false}
                                        style={{ width: 104, height: 104, overflow: 'hidden' }} 
                                    >
                                        {email_image ? (
                                            <Image
                                                preview={false}
                                                src={email_image}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 86, height: 86 }}>
                                                <PlusOutlined />
                                                <div style={{ marginTop: 8 }}>Upload</div>
                                            </div>
                                        )}
                                    </Upload>
                                </Form.Item>
                            </Badge>
                        </Form.Item>
                        <div style={{ color: '#888', fontSize: '12px', marginTop: '8px' }}>
                            This image will be displayed in email communications to customers.
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
}

export default ParkOverview;